<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="d-flex flex-column">
        <b-row class="sa-label-info">
          <b-col lg="3">
            <p>Record Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <div class="sa-flexbox-body">
        <div class="b-table-sticky-header">
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
            <template #cell(index)="row">
              {{ (currentPage - 1) * perPage + row.index + 1 }}
            </template>
            <template #cell(magazzino)="{ item }"> ({{ item.codiceMagazzino }}) {{ item.descrizioneMagazzino }} </template>
            <template #cell(indirizzo)="{ item }"
              >{{ item.comune }} ({{ item.provinciaMagazzino }}), {{ item.capMagazzino }}
              {{ item.indirizzoMagazzino }}
            </template>
            <template #cell(recapiti)="{ item }">
              <span class="sa-table-span-label-primary">Email: {{ item.emailMagazzino }} </span>
              <span class="sa-table-span-label-primary"> Telefono: {{ item.telefonoMagazzino }} </span>
              <span class="sa-table-span-label-primary">Fax: {{ item.faxMagazzino }}</span>
            </template>
            <template v-slot:cell(actions)="{ item }">
              <b-container class="bv-example-row">
                <!--         <b-button size="sm" v-b-tooltip.hover title="Visualizza Configurazione" variant="outline-secondary" @click="onClickViewConfigurazioneMagazzino(item)">
                                    <font-awesome-icon icon="eye"> </font-awesome-icon>
                                </b-button> -->
                <b-button size="sm" v-b-tooltip.hover title="Modifica Configurazione" variant="outline-success" @click="onClickEditConfigurazioneMagazzino(item)">
                  <font-awesome-icon icon="edit"> </font-awesome-icon>
                </b-button>
                <b-button size="sm" v-b-tooltip.hover title="Cancella Configurazione" variant="outline-danger" @click="onClickDeleteConfigurazioneMagazzino(item)">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </b-button>
              </b-container>
            </template>
          </b-table>
        </div>
        <!-- <configurazioni-magazzino-articoli-imballo-modal-edit-component ref="cmpConfigurazioneMagazzinoMagazziniEditModal" @saveMagazzino="loadDataMagazzino" @MagazzinoDelete="loadDataMagazzino" @onCloseModal="loadDataMagazzino" /> -->
        <configurazione-magazzino-magazzini-edit-component ref="cmpConfigurazioneMagazzinoMagazziniEditModal" @afterSave="onAfterSave"></configurazione-magazzino-magazzini-edit-component>
      </div>
      <div class="sa-list-component-footer">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Record Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioneMagazzinoMagazziniEditComponent from "./ConfigurazioneMagazzinoMagazziniEditComponent.vue";
export default {
  components: { ConfigurazioneMagazzinoMagazziniEditComponent },
  mixins: [UtilityMixin],
  data() {
    return {
      rows: 0,
      perPage: 50,
      id: null,
      currentPage: 1,
      pathResource: "/magazzinomagazzini",
      showModalLoading: false,
      listKey: 0,
      items: [],
      filtroConfigurazioneMagazzini: { codiceAzienda: null, descrizioneImballo: null },
      fields: [
        {
          label: "*",
          key: "index",
          sortable: false,
          thStyle: "width: 1rem",
        },
        {
          label: "Magazzino",
          key: "magazzino",
          sortable: false,
        },
        {
          label: "Tipo",
          key: "tipo",
          sortable: false,
        },
        {
          label: "Codice Azienda",
          key: "codiceAzienda",
          sortable: false,
        },

        {
          label: "Indirizzo",
          key: "indirizzo",
          sortable: false,
        },
        {
          label: "Recapiti",
          key: "recapiti",
          sortable: false,
        },
        {
          class: "sa-table-column-action-double",
          key: "actions",
          label: "",
        },
      ],
    };
  },
  mounted() {},
  watch: {
    currentPage() {
      let me = this;
      me.loadDataMagazzino();
    },
  },
  methods: {
    loadDataMagazzino() {
      let me = this;
      me.$emit("beforeLoadData");
      let sessionStorage = window.sessionStorage;
      if (sessionStorage["filtroConfigurazioneMagazzini"]) {
        me.filtroConfigurazioneMagazzini = JSON.parse(sessionStorage["filtroConfigurazioneMagazzini"]);
      }
      me.filtroConfigurazioneMagazzini.page = me.currentPage;
      me.filtroConfigurazioneMagazzini.forPage = me.perPage;
      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroConfigurazioneMagazzini, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.data.recordsNumber;
      me.$emit("afterLoadData");
    },
    loadDataError(error) {
      let me = this;
      console.error("Errore durante il caricamento dei dati:", error);
      me.items = [];
      me.rows = 0;
      me.$emit("afterLoadData");
    },
    onClickViewConfigurazioneMagazzino(item) {
      let me = this;
      me.$refs.cmpConfigurazioneMagazzinoMagazziniEditModal.show(item, true);
    },
    onClickEditConfigurazioneMagazzino(item) {
      let me = this;
      me.$refs.cmpConfigurazioneMagazzinoMagazziniEditModal.show(item, false);
    },
    onNuovoMagazzino() {
      let me = this;
      me.$refs.cmpConfigurazioneMagazzinoMagazziniEditModal.show(
        {
          codiceStruttura: null,
          codiceMagazzino: "",
          descrizioneMagazzino: "",
          tipo: null,
          telefonoMagazzino: "",
          faxMagazzino: "",
          emailMagazzino: "",
          provinciaMagazzino: null,
          localitaMagazzino: null,
          capMagazzino: "",
          indirizzoMagazzino: "",
        },
        false
      );
    },
    onClickDeleteConfigurazioneMagazzino(item) {
      let me = this;
      me.$refs.cmpConfigurazioneMagazzinoMagazziniEditModal.onDeleteMagazzino(item);
    },
    onAfterSave() {
      let me = this;
      me.loadDataMagazzino();
    },
  },
};
</script>
